App.ClientOrderBlockComponent = Em.Component.extend
  classNames: 'client-order-block'
  classNameBindings: ['isOpen']
  env: Em.inject.service('environment')

  orderStatus: (->
    @get('env').translate("order.status.#{@get('order.status')}")
  ).property('order.status')

  onOpenChange: (->
    if @get('isOpen')
      @$('.order-body').slideDown({duration: 100})
    else
      @$('.order-body').slideUp({duration: 100})
  ).observes('isOpen')

  click: ->
    @sendAction('onClick', @get('order.id'))


